import { MidaTradeParameters, } from "#trades/MidaTradeParameters";

export type OkxTradeParameters = MidaTradeParameters & {};
